<script>
import { merge } from 'lodash';

import XpcInput from './rtXpcInput.vue';
import InputMoney from './rtInputMoney.vue';
import InputNumber from './rtInputNumber.vue';
import RtAutocomplete from 'vue-xpc/src/element-ui/packages/autocomplete';

export default {
  name: 'RtInput',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: [String, Number],
    placeholder: String
  },
  data () {
    return {
      /**
       * @private
       *
       * 用于透传的ref对象
       */
      proxyRef: undefined
    };
  },

  computed: {
    component () {
      switch (this.$attrs.type) {
        case 'money':
          return InputMoney;
        case 'number':
          return InputNumber;
        case 'autocomplete':
          return RtAutocomplete;
        default:
          return XpcInput;
      }
    }
  },

  created () {
    this._proxySlotsUsage();
  },

  mounted () {
    this._proxyRefUsage();
  },

  methods: {
    /**
     * @private
     *
     * 对父元素使用slot的情况进行属性透传，此函数需要在created时进行
     */
    _proxySlotsUsage () {
      Object.defineProperty(this.$refs, 'proxyRef', {
        get: () => this.proxyRef,
        set: ref => {
          this.proxyRef = merge(ref, { $slots: this.$slots });
        }
      });
    },

    /**
     * @private
     *
     * 查找当前组件被ref指向的节点对象
     */
    _findRefOwner (curNode, dstNode) {
      let refKey;
      let refOwner;

      if (curNode && curNode.$refs) {
        const _key = Object.keys(curNode.$refs).find(key => {
          if (Array.isArray(curNode.$refs[key])) {
            // 暂不考虑ref为数组的情况
            return false;
          } else {
            return curNode.$refs[key] === dstNode;
          }
        });

        if (_key) {
          refKey = _key;
          refOwner = curNode;
        } else {
          // 递归查找父节点
          const res = this._findRefOwner(curNode.$parent, dstNode);

          refKey = res.refKey;
          refOwner = res.refOwner;
        }
      }

      return { refKey, refOwner };
    },

    /**
     * @private
     *
     * 对父元素使用ref的情况进行属性透传，此函数需要在mounted时进行
     */
    _proxyRefUsage () {
      const { refKey, refOwner } = this._findRefOwner(this.$parent, this);
      if (refKey && refOwner) {
        refOwner.$refs[refKey] = new Proxy(this, {
          get: (target, key) => {
            if (key.startsWith('xpc')) {
              return this[key];
            } else if (key === '$owner') {
              return this;
            } else if (key.startsWith('$owner_')) {
              return this[key.replace('$owner_', '')];
            } else {
              return this.$refs.proxyRef[key];
            }
          }
        });
      }
    }
  },

  render (h) {
    const data = {
      ref: 'proxyRef',
      props: { ...this.$attrs, ...this.$props },
      attrs: { ...this.$attrs, ...this.$props },
      on: this.$listeners,
      scopedSlots: { ...this.$scopedSlots }
    };

    return h(this.component, data);
  }
};
</script>



// WEBPACK FOOTER //
// rtInput.vue?0d26c0f5